import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'error-dialog',
  templateUrl: './error-dialog.html'
})
export class ErrorDialog implements OnInit {

  error: string;

  constructor(public dialogRef: MatDialogRef<ErrorDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.error = data.error;
  }

  ngOnInit() { }

  closeDialog() {
    this.dialogRef.close();
  }

  copy() {
    let range = document.createRange();
    range.selectNode(document.getElementById("error"));
    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges();// to deselect
  }

}
